require('./video-item/video-item.scss');
var BaseViews = require('../base');
var VideoItem = BaseViews.LayoutView.extend({
  className:
      'fmcy-video-item',
  template: require('./video-item/video-item.html'),
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              videoStyle: 'thumb',
              extraClassName: null
          }
      );
  },
  ui: {
      videoImage: '.fmcy-video-item-image'
  },
  events: {
      'click': 'onClick'
  },
  onClick: function() {
      this.trigger('thumb:clicked');
  },
  onRender: function () {
    if (this.options.extraClassName) {
        this.$el.addClass(this.options.extraClassName);
    }
    var imageURL = this.model.get('image_medium_url');

    this.ui.videoImage.css(
        'background-image',
        'url(' +imageURL + ')'
    );
  },
  serializeData: function () {
    return {
      videoStyle: this.options.videoStyle,
      description: this.model.get('description'),
      name: this.model.get('name')
    };
  }
});

module.exports = VideoItem;



/** WEBPACK FOOTER **
 ** ./assets/js/common/video-group/video-item.js
 **/